var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-changeAssignee" },
    [
      (_vm.options.groups && _vm.users.length) || _vm.isMultiInstance
        ? _c(
            "van-popup",
            {
              style: { width: "100%" },
              attrs: { position: "bottom", "get-container": "body" },
              model: {
                value: _vm.groupVisible,
                callback: function ($$v) {
                  _vm.groupVisible = $$v
                },
                expression: "groupVisible",
              },
            },
            [
              _c("van-nav-bar", {
                attrs: {
                  title: _vm.isMultiInstance ? "转办用户组" : "转办他人",
                  "left-text": "取消",
                  "right-text": "确定",
                },
                on: {
                  "click-left": function ($event) {
                    _vm.groupVisible = false
                  },
                  "click-right": _vm.onGroupConfirm,
                },
              }),
              _vm._v(" "),
              _vm.isMultiInstance
                ? _c(
                    "van-radio-group",
                    {
                      model: {
                        value: _vm.group,
                        callback: function ($$v) {
                          _vm.group = $$v
                        },
                        expression: "group",
                      },
                    },
                    [
                      _c(
                        "van-cell-group",
                        { staticClass: "radio-group-container" },
                        _vm._l(_vm.groups, function (item, index) {
                          return _c(
                            "van-cell",
                            {
                              key: index,
                              staticClass: "van-cell-offset",
                              attrs: { clickable: "" },
                            },
                            [
                              _c(
                                "van-radio",
                                { attrs: { name: item.id } },
                                [
                                  _c("template", { slot: "props" }, [_c("i")]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.name) +
                                      "\n          "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "van-radio-group",
                    {
                      model: {
                        value: _vm.user,
                        callback: function ($$v) {
                          _vm.user = $$v
                        },
                        expression: "user",
                      },
                    },
                    [
                      _c(
                        "van-cell-group",
                        { staticClass: "radio-group-container" },
                        _vm._l(_vm.users, function (item, index) {
                          return _c(
                            "van-cell",
                            {
                              key: index,
                              staticClass: "van-cell-offset",
                              attrs: { clickable: "" },
                            },
                            [
                              _c(
                                "van-radio",
                                { attrs: { name: item.userId } },
                                [
                                  _c("template", { slot: "props" }, [_c("i")]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.userName) +
                                      "\n          "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.options.groups || _vm.emptyUsers
        ? _c("emap-flow-pick-m", {
            on: { "on-confirm": _vm.onConfirm },
            model: {
              value: _vm.visible,
              callback: function ($$v) {
                _vm.visible = $$v
              },
              expression: "visible",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }